// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"79a6639d","29":"bdae74c7","264":"61da5a27","472":"3c4407a4","685":"58c6b362","867":"b8c53be3"}[chunkId] + ".chunk.css";
};